import { Root } from '@radix-ui/react-dialog'
import type { ComponentProps } from 'react'

type RootProps = ComponentProps<typeof Root>

export interface DialogProps extends RootProps {
  children?: RootProps['children']
  defaultOpen?: RootProps['defaultOpen']
  open?: RootProps['open']
  onOpenChange?: RootProps['onOpenChange']
  modal?: RootProps['modal']
}

export const Dialog = Root
